export const tailwindClassnames = {
  appContainer:
    "App bg-primary-off-white dark:bg-storm-blue-dark transition duration-300",

  tableTitle:
    "text-storm-blue dark:text-sky-blue-light font-medium text-4xl transition duration-300",
  tableHead:
    "bg-off-white-dark dark:bg-storm-blue text-left border border-2 border-off-white-dark dark:border-storm-blue border-b-storm-blue-light dark:border-b-sky-blue transition duration-300",
  tableHeadText:
    "py-2 px-4 font-light text-off-black-dark dark:text-primary-off-white transition duration-300",
  tableHeadButton:
    "py-2 px-4 font-light text-primary-off-black dark:text-primary-off-white transition duration-300 text-center",
  tableBodyCells:
    "bg-primary-off-white hover:bg-off-white-dark dark:bg-storm-blue-dark dark:hover:bg-storm-blue cursor-pointer border-b border-b-off-white-dark dark:border-off-black-light transition duration-300",
  /**
   * Table body cell text styling that CSS-truncates with an ellipsis when the
   * content exceeds max-w-xs. Consumers rendering variable-length user data
   * MUST also set `title={value}` on the cell so the full text is recoverable
   * on hover. See `aimodelzoo/PredictionRunHistory.tsx` for the reference
   * pattern.
   */
  tableBodyText:
    "text-primary-off-black dark:text-primary-off-white text-sm py-2 px-4 text-left overflow-hidden text-ellipsis whitespace-nowrap max-w-xs transition duration-300",
  tableBodyButton:
    "text-center text-primary-off-black dark:text-primary-off-white transition duration-300",
  sortingArrows: "text-sky-blue-dark",
  tableContainer: "text-left w-full",

  addButton:
    "bg-sky-blue text-storm-blue font-medium py-2 px-4 rounded shadow shadow-off-white-dark dark:shadow-storm-blue ml-3 transition duration-300",
  searchButton:
    "bg-sky-blue text-storm-blue px-3 py-2 h-fit rounded shadow shadow-off-white-dark dark:shadow-storm-blue ml-3 transition duration-300",
  saveButton:
    "bg-sky-blue text-storm-blue font-bold py-2 px-4 rounded shadow-sm shadow-off-white-dark dark:shadow-storm-blue-dark ml-4 transition duration-300",
  disabledSaveButton:
    "bg-sky-blue-dark text-storm-blue-light font-bold py-2 px-4 rounded ml-4",
  cancelButton:
    "bg-storm-blue-light text-sky-blue font-bold py-2 px-4 rounded shadow-sm shadow-off-white-dark dark:shadow-storm-blue-dark transition duration-300",
  decommissionButton:
    "bg-storm-blue text-sky-blue font-bold py-2 px-4 rounded shadow-sm shadow-storm-blue-dark ml-4",
  disabledCancelButton:
    "bg-storm-blue text-storm-blue-light font-bold py-2 px-4 rounded ml-4",
  disabledAddButton:
    "bg-sky-blue-dark text-storm-blue-light font-medium py-2 px-4 rounded shadow shadow-storm-blue",

  textInputLabel:
    "mb-1 text-off-black-light dark:text-primary-off-white text-sm font-light transition duration-300",
  textInputLabelDisabled: "mb-1 text-greyed-text text-sm font-light",
  textInputSearch:
    "p-2 w-52 rounded text-primary-off-black dark:text-off-white-dark bg-white border border-off-white-dark dark:border-off-black-light dark:bg-storm-blue w-full placeholder-off-black-light text-sm transition duration-300",
  // Date-range filter in a table toolbar: tableFilterInput at a wider size, so
  // the date picker sits on the same surface, border and height as the text
  // filters beside it in both themes.
  tableFilterDateInput:
    "h-[34px] w-60 rounded-lg border border-off-white-dark bg-white px-2.5 text-sm text-primary-off-black placeholder-greyed-text transition duration-300 focus:border-sky-blue-dark focus:outline-none focus:ring-2 focus:ring-storm-blue dark:focus:ring-sky-blue dark:border-storm-blue-border dark:bg-storm-blue dark:text-off-white-dark",
  checkBoxLabel:
    "text-primary-off-black dark:text-primary-off-white text-sm font-light inline-block mx-2 transition duration-300",
  checkBox:
    "mt-1 accent-storm-blue dark:accent-sky-blue cursor-pointer transition duration-300",

  warningLabel:
    "text-orange-200 rounded-sm font-bold bg-orange-700 px-2 py-1 text-sm",
  warningHeader:
    "text-orange-700 dark:text-orange-200 rounded-sm font-bold bg-orange-200 dark:bg-orange-700 px-2 py-1 text-lg transition duration-300",
  basicLabel:
    "text-primary-off-black dark:text-primary-off-white text-sm font-light mb-3 transition duration-300",
  dropdownLabel:
    "text-off-black-light dark:text-primary-off-white text-sm font-light mb-1",
  basicSubHeading:
    "text-storm-blue dark:text-sky-blue-light text-left text-2xl font-light mb-2 mt-6 transition duration-300",
  // Muted, comfortably-spaced descriptive/help text under a heading or control.
  helperText:
    "text-left text-sm text-off-black-light dark:text-off-white-dark leading-relaxed transition duration-300",

  formSection:
    "flex flex-wrap shadow border border-primary-off-white dark:border-storm-blue transition duration-300 p-3 m-3 rounded-sm",

  // Section card + header (titled cards used on the Project Details overview).
  // Dark-mode colors match `tableCard` (bg-storm-blue-card / border-storm-blue-border)
  // so cards look the same whether they're a list-page table or a form section.
  formSectionCard:
    "bg-white dark:bg-storm-blue-card border border-off-white-dark dark:border-storm-blue-border rounded-[10px] shadow-sm p-6 transition duration-300",
  formSectionHeader:
    "mb-5 pb-3 border-b border-off-white-dark dark:border-storm-blue-border",
  formSectionTitle:
    "text-storm-blue dark:text-primary-off-white text-[15px] font-semibold transition duration-300",

  // Grid layout (replaces flex flex-wrap + per-field margins)
  formGrid: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 items-start",
  formGridFull: "md:col-span-2", // add to any field wrapper that should span full width
  formField: "flex flex-col", // per-field wrapper (replaces detailsPageTextInputContainer)

  // Stack of section cards (replaces the single shadow-lg form padding block)
  formSectionStack: "flex flex-col gap-5",

  // Sticky action bar
  formActionBar:
    "sticky bottom-0 flex justify-end gap-3 py-4 bg-primary-off-white/90 dark:bg-storm-blue-dark/90 backdrop-blur-sm border-t border-off-white-dark dark:border-storm-blue-light transition duration-300",

  detailsPageTitle:
    "text-storm-blue dark:text-sky-blue-light font-medium text-left text-4xl mb-2 transition duration-300",
  detailsPageTextInputContainer: "w-full md:w-1/2 px-3 mb-6 md:mb-0",
  detailsPageTextInput:
    "rounded px-3 py-2 text-primary-off-black dark:text-off-white-dark bg-white border border-off-white-dark dark:border-off-black-light dark:bg-storm-blue w-full placeholder-off-black-light transition duration-300 focus:outline-none focus:ring-2 focus:ring-storm-blue dark:focus:ring-sky-blue focus:border-sky-blue-dark",
  detailsPageTextInputDisabled:
    "rounded px-3 py-2 text-off-black-light dark:text-greyed-text bg-off-white-dark dark:bg-storm-blue w-full placeholder-greyed-text",
  detailsPageTextArea:
    "rounded px-3 py-2 text-primary-off-black dark:text-off-white-dark bg-white dark:bg-storm-blue border border-off-white-dark dark:border-off-black-light w-full h-48 placeholder-storm-blue-light transition duration-300",
  detailsPageTextAreaDisabled:
    "rounded px-3 py-2 text-storm-blue-light bg-storm-blue w-full h-48 placeholder-storm-blue-light",

  detailsActiveTab:
    "bg-off-white-dark dark:bg-storm-blue-light text-storm-blue dark:text-primary-off-white font-medium pt-2 pb-1 mb-1 px-4 border border-x-off-white-dark border-t-off-white-dark border-b-storm-blue dark:border-x-storm-blue-light dark:border-t-storm-blue-light dark:border-b-sky-blue transition duration-300",
  detailsInactiveTab:
    "text-storm-blue-dark dark:text-off-white-dark font-medium pt-2 pb-1 mb-1 px-4 transition duration-300",

  /** @deprecated Admin style refresh — use modalOverlay (+ a per-consumer z-* class) instead. */
  modalContainer:
    "z-50 fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center max-h-full overflow-y-auto",
  /** @deprecated Admin style refresh — use modalHeaderRow + modalTitle instead. */
  modalHeader:
    "text-center font-medium text-storm-blue dark:text-primary-off-white text-2xl pb-0 transition duration-300",
  /** @deprecated Admin style refresh — use modalPanel (+ a max-w-* class) instead. */
  modalBackground:
    "bg-primary-off-white dark:bg-storm-blue-light rounded text-left p-8 min-w-[300px] space-y-4 translate-y-20 transition duration-300",
  /** @deprecated Admin style refresh — use modalPanel (+ a wider max-w-* class) instead. */
  formBackground:
    "bg-primary-off-white dark:bg-storm-blue-dark rounded text-left p-8 min-w-[300px] w-1/2 space-y-4 translate-y-10",

  // --- Admin style refresh: button hierarchy --------------------------------
  // One vocabulary for every button: primary (filled storm-blue, inverts to
  // sky-blue in dark mode), secondary (outline), danger (filled red, for
  // destructive confirms), ghost (borderless, low-emphasis). Disabled state is
  // built in via the `disabled` attribute — no separate "disabled*" constants.
  btnPrimary:
    "rounded-lg bg-storm-blue px-3.5 py-2 text-sm font-semibold text-white transition duration-150 hover:bg-storm-blue/85 focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue focus-visible:ring-offset-2 dark:focus-visible:ring-sky-blue dark:focus-visible:ring-offset-storm-blue-card disabled:cursor-not-allowed disabled:opacity-45 dark:bg-sky-blue dark:text-primary-blue-dark dark:hover:bg-sky-blue-light",
  btnSecondary:
    "rounded-lg border border-off-white-dark bg-white px-3.5 py-2 text-sm font-semibold text-primary-off-black transition duration-150 hover:border-greyed-text focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue dark:focus-visible:ring-sky-blue disabled:cursor-not-allowed disabled:opacity-45 dark:border-storm-blue-border dark:bg-transparent dark:text-primary-off-white dark:hover:border-storm-blue-light",
  // Destructive actions use the app's established primary-orange (matches the
  // Reset/Delete/Exclude links and the AI Mappings dialogs) — sign-off 2026-08-04.
  btnDanger:
    "rounded-lg bg-primary-orange px-3.5 py-2 text-sm font-semibold text-white transition duration-150 hover:bg-primary-orange-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue focus-visible:ring-offset-2 dark:focus-visible:ring-sky-blue dark:focus-visible:ring-offset-storm-blue-card disabled:cursor-not-allowed disabled:opacity-45",
  // Filter-toolbar apply action: btnSecondary is an outline on a white/
  // transparent fill, which disappears into the table card, so the toolbar gets
  // a tinted variant in the sky-blue accent already used by the active filter
  // chips. Deliberately lighter than btnPrimary so it stays secondary to the
  // create action sitting beside it (sign-off 2026-08-11).
  btnFilterApply:
    "rounded-lg border border-sky-blue-dark bg-sky-blue/25 px-3.5 py-2 text-sm font-semibold text-storm-blue transition duration-150 hover:bg-sky-blue/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue dark:focus-visible:ring-sky-blue disabled:cursor-not-allowed disabled:opacity-45 dark:bg-sky-blue/15 dark:text-sky-blue dark:hover:bg-sky-blue/25",
  btnGhost:
    "rounded-lg px-3.5 py-2 text-sm font-semibold text-off-black-light transition duration-150 hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue dark:focus-visible:ring-sky-blue disabled:cursor-not-allowed disabled:opacity-45 dark:text-off-white-dark dark:hover:bg-white/10",

  // --- Admin style refresh: dialog anatomy ----------------------------------
  // Every modal follows: overlay > panel > headerRow (title + closeButton),
  // body, footer (actions right-aligned, confirm on the right). modalOverlay
  // deliberately carries no z-index — append a per-consumer z-* class so
  // stacking stays explicit (e.g. `z-50`, or `z-[1200]` above the review
  // full-screen layer). modalPanel carries no max-width — append a max-w-*
  // class (max-w-md for confirms, max-w-2xl for form modals).
  // Scroll model: the OVERLAY scrolls, never the panel — the panel's m-auto
  // centers short dialogs and keeps tall ones reachable from the top. Do not
  // add overflow/max-h to the panel: it would clip non-portaled popups
  // (react-select menus, datepicker calendars) rendered inside dialogs.
  modalOverlay:
    "fixed inset-0 flex overflow-y-auto bg-storm-blue-dark/45 p-4 backdrop-blur-sm",
  modalPanel:
    "relative m-auto w-full rounded-2xl bg-white text-left shadow-2xl transition duration-300 dark:bg-storm-blue-card",
  modalHeaderRow: "flex items-start justify-between gap-3 px-5 pt-4",
  modalTitle:
    "text-base font-semibold tracking-tight text-storm-blue transition duration-300 dark:text-primary-off-white",
  modalCloseButton:
    "flex h-7 w-7 flex-none items-center justify-center rounded-lg text-lg leading-none text-off-black-light hover:bg-black/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-storm-blue dark:focus-visible:ring-sky-blue disabled:cursor-default disabled:opacity-40 dark:text-off-white-dark dark:hover:bg-white/10",
  modalBody:
    "px-5 pb-5 pt-2 text-sm leading-relaxed text-off-black-light transition duration-300 dark:text-off-white-dark",
  // Footer is a full-bleed tinted band (adopted from the AI Mappings dialogs —
  // blend sign-off 2026-08-04) so actions sit on their own surface; it rounds
  // its own bottom corners so the panel needs no overflow clipping (which
  // would cut off select menus).
  modalFooter:
    "flex justify-end gap-2.5 rounded-b-2xl border-t border-off-white-dark bg-off-white-dark/60 px-5 py-3.5 dark:border-storm-blue-border dark:bg-storm-blue-light/15",
  // Orange icon badge rendered beside the title on destructive confirms
  // (same primary-orange family as btnDanger).
  modalDangerIcon:
    "flex h-9 w-9 flex-none items-center justify-center rounded-[10px] bg-primary-orange/15 text-lg font-bold text-primary-orange-dark dark:bg-primary-orange/25 dark:text-primary-orange-light",

  // --- Admin style refresh: list-page pattern --------------------------------
  // Page header (title + subtitle + primary action) above a table card:
  // filter toolbar attached to the card top, quiet caps column headers,
  // pagination in the card footer (nothing fixed/floating).
  pageHeaderRow: "mb-4 flex items-start justify-between gap-4",
  pageTitle:
    "text-left text-4xl font-semibold tracking-tight text-storm-blue transition duration-300 dark:text-primary-off-white",
  pageSubtitle:
    "mt-0.5 text-left text-[13px] text-off-black-light transition duration-300 dark:text-greyed-text",
  tableCard:
    "overflow-hidden rounded-xl border border-off-white-dark/70 bg-white shadow-sm transition duration-300 dark:border-storm-blue-border dark:bg-storm-blue-card",
  tableCardToolbar:
    "flex flex-wrap items-end gap-3 border-b border-off-white-dark/60 px-4 py-3.5 dark:border-storm-blue-border",
  tableFilterInput:
    "h-[34px] w-44 rounded-lg border border-off-white-dark bg-white px-2.5 text-sm text-primary-off-black placeholder-greyed-text transition duration-300 focus:border-sky-blue-dark focus:outline-none focus:ring-2 focus:ring-storm-blue dark:focus:ring-sky-blue dark:border-storm-blue-border dark:bg-storm-blue dark:text-off-white-dark",
  tableCardHeadCell:
    "border-b border-off-white-dark/60 px-4 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wider text-off-black-light transition duration-300 dark:border-storm-blue-border dark:text-greyed-text",
  tableCardRow:
    "cursor-pointer border-b border-off-white-dark/50 transition duration-150 hover:bg-sky-blue-light/20 dark:border-storm-blue-border/60 dark:hover:bg-white/5",
  /**
   * Table-card body cell that CSS-truncates with an ellipsis past max-w-xs.
   * Same contract as tableBodyText: consumers rendering variable-length user
   * data MUST also set `title={value}` on the cell so the full text is
   * recoverable on hover.
   */
  tableCardCell:
    "max-w-xs overflow-hidden text-ellipsis whitespace-nowrap px-4 py-3 text-left text-sm text-primary-off-black transition duration-300 dark:text-primary-off-white",
  tableCardCellPrimary:
    "max-w-xs overflow-hidden text-ellipsis whitespace-nowrap px-4 py-3 text-left text-sm font-medium text-storm-blue transition duration-300 dark:text-primary-off-white",
  tableCardFooter:
    "flex flex-row items-center justify-between px-4 py-2 text-sm text-off-black-light transition duration-300 dark:text-greyed-text",
  chipActive:
    "rounded-full bg-primary-green/15 px-2.5 py-0.5 text-[11px] font-semibold text-primary-green dark:bg-primary-green-light/15 dark:text-primary-green-light",
  chipInactive:
    "rounded-full bg-greyed-text/20 px-2.5 py-0.5 text-[11px] font-semibold text-off-black-light dark:bg-greyed-text/25 dark:text-greyed-text",
  // Status chips for import/upload event history (see helpers.tsx eventStatusChipClass).
  chipInProgress:
    "rounded-full bg-primary-blue/15 px-2.5 py-0.5 text-[11px] font-semibold text-primary-blue dark:bg-primary-blue-light/20 dark:text-primary-blue-light",
  chipFailed:
    "rounded-full bg-primary-orange/15 px-2.5 py-0.5 text-[11px] font-semibold text-primary-orange dark:bg-primary-orange/20 dark:text-primary-orange",
  // Non-interactive table-card row (no cursor/hover tint) — for read-only
  // tables like event histories.
  tableCardRowStatic:
    "border-b border-off-white-dark/50 transition duration-150 last:border-b-0 dark:border-storm-blue-border/60",

  // --- Admin style refresh: app shell ----------------------------------------
  // Top-bar nav pills and side-menu items share one active treatment: white
  // pill (storm-blue card in dark) with the accent text color.
  navPill:
    "px-3 py-2 rounded-lg text-sm font-medium text-off-black-light hover:text-primary-blue-dark transition duration-300 dark:text-off-white-dark dark:hover:text-sky-blue",
  navPillActive:
    "px-3 py-2 rounded-lg text-sm font-semibold bg-white text-primary-blue-dark shadow-sm transition duration-300 dark:bg-storm-blue dark:text-sky-blue",
  sideNavItem:
    "block w-full my-1 px-3 py-2 rounded-lg text-sm font-medium text-off-black-light hover:bg-black/5 transition duration-300 dark:text-off-white-dark dark:hover:bg-white/5",
  sideNavItemActive:
    "block w-full my-1 px-3 py-2 rounded-lg text-sm font-semibold bg-white text-primary-blue-dark shadow-sm transition duration-300 dark:bg-storm-blue dark:text-sky-blue",
  // Dropdown menu card (e.g. the header profile menu) + its items. No
  // overflow-hidden — the Language item pops open a submenu below itself
  // that needs to render outside the card's bounds; the first/last menuItem
  // usages carry their own rounded-t-xl/rounded-b-xl instead so hovering
  // them still respects the card's rounded corners.
  menuCard:
    "absolute right-0 top-16 z-30 mr-4 w-44 rounded-xl border border-off-white-dark bg-white text-left shadow-lg transition duration-300 dark:border-storm-blue-border dark:bg-storm-blue-card",
  menuItem:
    "block w-full cursor-pointer px-4 py-2.5 text-left text-sm text-primary-off-black transition duration-150 hover:bg-sky-blue-light/30 dark:text-primary-off-white dark:hover:bg-white/10",

  paginationContainer:
    "fixed bottom-0 left-48 right-8 px-3 pt-3 flex flex-row justify-between bg-primary-off-white/50 dark:bg-storm-blue/50 backdrop-blur-sm  transition duration-300",

  noHover: "cursor-default",

  // --- Full-screen review resolved-state visuals (AKL-698) -----------------
  // Shared by SuggestionCard (rejected) and ObservationList row (accepted) so
  // the two resolved treatments stay in visual lockstep.
  // Muted background for cards in a resolved state; strikethrough is applied
  // per-element (on the species/count text) rather than on the whole card so
  // action buttons and chips inside stay legible.
  resolvedCardBase:
    "bg-black/[0.04] text-off-black-light/70 dark:bg-white/[0.04] dark:text-primary-off-white/60",
  resolvedTextStrike: "line-through",
  resolvedBarRejected: "border-l-4 border-l-red-500 dark:border-l-red-400",
  resolvedBarAccepted: "border-l-4 border-l-green-500 dark:border-l-green-400",
  resolvedChipRejected:
    "rounded bg-red-500/15 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-red-700 dark:bg-red-500/20 dark:text-red-300",
  resolvedChipAccepted:
    "rounded bg-green-500/15 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-green-700 dark:bg-green-500/20 dark:text-green-300",
  // Card outline mirror for pointer-selected cards — visually distinct from
  // the existing keyboard-focused visual (which uses a solid ring).
  cardPointerSelected:
    "outline outline-2 outline-offset-2 outline-sky-blue-light",

  // --- AI Mappings label-first view (AKL-715) -------------------------------
  filterChipActive:
    "rounded-full px-3 py-1 text-xs font-semibold border border-sky-blue-dark bg-sky-blue/20 text-sky-blue-dark dark:text-sky-blue whitespace-nowrap transition duration-300",
  filterChipInactive:
    "rounded-full px-3 py-1 text-xs border border-off-white-dark dark:border-off-black-light text-primary-off-black dark:text-primary-off-white bg-transparent whitespace-nowrap transition duration-300",
  matchChip:
    "rounded text-[10px] px-1.5 py-0.5 text-sky-blue-dark dark:text-sky-blue bg-sky-blue/15",
  customizedChip:
    "text-[10px] font-semibold text-sky-blue-dark dark:text-sky-blue inline-flex items-center gap-1",
  // Muted "inactive" badge for an enabled-but-globally-inactive model (AKL-729)
  // — display-only, never gates: the model keeps appearing everywhere it's
  // enabled, this just explains why.
  inactiveModelBadge:
    "rounded text-[10px] px-1.5 py-0.5 text-greyed-text bg-off-white-dark dark:bg-storm-blue-light/20 whitespace-nowrap",
  segmentedControlActive:
    "px-2.5 py-1 text-xs font-semibold bg-sky-blue text-storm-blue cursor-pointer whitespace-nowrap",
  segmentedControlInactive:
    "px-2.5 py-1 text-xs text-off-black-light dark:text-greyed-text bg-white dark:bg-storm-blue cursor-pointer whitespace-nowrap",
  // NOTE: the AKL-715-scoped mappingsDialog*/destructiveButton constants were
  // absorbed into the app-wide blended dialog anatomy (modal* + btnDanger,
  // sign-off 2026-08-04) and removed — the tinted footer band lives on in
  // modalFooter, and the destructive primary-orange in btnDanger.

  stormBlue: "#272837",
  skyBlue: "#B0E6FA",
  skyBlueDark: "#6C939E",
  greyedText: "#999999",
  stormBlueLight: "#6E6E7F",
  primaryOffWhite: "#EDEDED",
  offBlackLight: "#626262",
};

export default tailwindClassnames;
